/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_EveryInputs */

const en_us2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every day`)
};

const pt_br2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os dias`)
};

const es_419_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los días`)
};

const pt_pt2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os dias`)
};

const fr_fr2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les jours`)
};

const de_de2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden Tag`)
};

const it_it2_profile_editors_reminder_every = /** @type {(inputs: Profile_Editors_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni giorno`)
};

/**
* | output |
* | --- |
* | "Every day" |
*
* @param {Profile_Editors_Reminder_EveryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_every = /** @type {((inputs?: Profile_Editors_Reminder_EveryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_EveryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_every(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_every(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_every(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_every(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_every(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_every(inputs)
	return en_us2_profile_editors_reminder_every(inputs)
});
export { profile_editors_reminder_every as "profile-editors.reminder_every" }